
// Reexport everything from the supabase directories for easier imports throughout the app
export * from './supabase/client';
export * from './supabase/auth';
export * from './supabase/db/classes';
export * from './supabase/db/bookings';
export * from './supabase/db/users';
export * from './supabase/db/subscriptions';
export * from './supabase/db/gift-cards';
export * from './supabase/types';
export * from './supabase/index'; // This will ensure we get the scheduleClasses function

import { supabase } from './supabase/client';

export const fetchUserBookings = async (userId: string, email: string = '') => {
  try {
    let query = supabase
      .from('bookings')
      .select(`
        *,
        classes:class_id (
          title,
          day,
          time,
          date,
          image
        )
      `);

    // Filter by userId if provided, otherwise by email
    if (userId) {
      query = query.eq('user_id', userId);
    } else if (email) {
      query = query.eq('email', email);
    }

    // With RLS policies in place, this will automatically filter to:
    // - All bookings for admins
    // - Only the user's own bookings for regular users
    const { data, error } = await query;
    
    if (error) {
      throw error;
    }
    
    // Process the data to provide a consistent shape
    return data.map(booking => ({
      id: booking.id,
      userId: booking.user_id,
      classId: booking.class_id,
      classDate: booking.classes?.date,
      classDay: booking.classes?.day,
      classTime: booking.classes?.time,
      className: booking.classes?.title,
      classImage: booking.classes?.image,
      firstName: booking.first_name,
      lastName: booking.last_name,
      email: booking.email,
      phone: booking.phone,
      groupSize: booking.group_size,
      groupNames: booking.group_names,
      createdAt: booking.created_at,
      paymentStatus: booking.payment_status,
      giftCardId: booking.gift_card_id,
      subscriptionId: booking.subscription_id
    }));
  } catch (error) {
    console.error('Error fetching user bookings:', error);
    throw error;
  }
};

export const updateBookingPaymentStatus = async (
  bookingId: string, 
  paymentStatus: 'pending' | 'paid' | 'nptr'
): Promise<{ success: boolean; error?: string }> => {
  try {
    // RLS policies will ensure only users with proper permissions can update
    const { error } = await supabase
      .from('bookings')
      .update({ payment_status: paymentStatus })
      .eq('id', bookingId);
    
    if (error) throw error;
    
    return { success: true };
  } catch (error: any) {
    console.error('Error updating booking payment status:', error);
    return { 
      success: false, 
      error: error.message || 'Failed to update booking payment status' 
    };
  }
};
